import React from 'react'
import Profile from './index'
import PropTypes from 'prop-types'

const ProfileCollection = ({data}) => {

  if(!Array.isArray(data) && (Array.isArray(data) && data.length < 1)){
    return null;
  }
  return (
    <div>
    {
      data.map((item, i)=>{
        return(
          <div key={i}>
              <Profile comment={item.comment} description={item.description} emailId={item.emailId} link={item.link} occupation={item.occupation} phone={item.phone} phoneDisplay={item.phoneDisplay} title={item.title}  />
          </div>
        )
      })
    }
    </div>
  )
}

ProfileCollection.propTypes = {
  data : PropTypes.arrayOf(
    PropTypes.shape({
      comment : PropTypes.arrayOf(PropTypes.string).isRequired,
      description :  PropTypes.string.isRequired,
      emailId :  PropTypes.string.isRequired,
      link :  PropTypes.string.isRequired,
      occupation :  PropTypes.string.isRequired,
      phone : PropTypes.string,
      phoneDisplay :  PropTypes.string.isRequired,
      title :  PropTypes.string.isRequired,
    })
  )
}



export default ProfileCollection